import {h} from 'ui/Framework';

export default h('svg', {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '48',
  height: '40',
  viewBox: '0 0 48 40'
}, [
  h('path', {
    d: 'M41 5v4H11v25c0 2.8-2.2 5-5 5s-5-2.2-5-5V1h14v4h26z',
    fill: '#c0f2d6'
  }),
  h('path', {
    d: 'M47 8h-5V5c0-.6-.4-1-1-1H16V1c0-.6-.4-1-1-1H1C.4 0 0 .4 0 1v33c0 3.3 2.7 6 6 6h35c3.9 0 7-3.1 7-7V9c0-.6-.4-1-1-1zM2 34V2h12v3c0 .6.4 1 1 1h25v2H11c-.6 0-1 .4-1 1v25c0 2.2-1.8 4-4 4s-4-1.8-4-4zm44-1c0 2.8-2.2 5-5 5H10.5c1-1.1 1.5-2.5 1.5-4V10h34v23z',
    fill: '#0eb87f'
  }),
  h('path', {
    d: 'M39 32H19c-.4 0-.7-.2-.9-.6-.2-.4-.1-.8.1-1.1l5-6c.3-.4.8-.5 1.2-.3l3.3 1.7 5.5-6.4c.2-.3.6-.4.9-.3.3 0 .6.3.8.6l5 11c.1.3.1.7-.1 1-.1.2-.5.4-.8.4zm-17.9-2h16.3l-3.7-8.2-5 5.8c-.3.3-.8.4-1.2.2l-3.3-1.6-3.1 3.8zM23 22c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z',
    fill: '#0eb87f'
  })
]);



// WEBPACK FOOTER //
// ./src/javascripts/svg/page-media.es6.js